import { styled } from 'goober';

export const Wrapper = styled('div')`
    position: relative;
    display: flex;
    width: 100%;
    min-height: 300px;
    flex-grow: 1;
    align-items: center;
    justify-content: center;
    overflow: hidden;
`;
